import { Badge } from '@roger/ui-components';

/**
 * Canonical tooltip for the test-patient marker. Comprehensive on purpose: it
 * states the full consequence (never billed; excluded from every payer/CMS exit)
 * so the badge reads truthfully wherever it appears — patient list, patient
 * header, or a billing table where only claims are in view.
 */
export const TEST_PATIENT_BADGE_TITLE =
  'Test patient — never billed; excluded from claims, NOA, and CMS surveys.';

interface TestPatientBadgeProps {
  /** Layout-only classes for the call site (e.g. `shrink-0` inside a flex row). */
  className?: string;
}

/**
 * Single source of truth for the test/practice-patient marker — label, styling,
 * and tooltip. Render conditionally on `is_test_patient`; this component does not
 * gate itself, so the caller stays in control of when the marker appears.
 */
export function TestPatientBadge({ className }: TestPatientBadgeProps) {
  return (
    <Badge
      variant='secondary'
      className={className}
      title={TEST_PATIENT_BADGE_TITLE}
    >
      Test
    </Badge>
  );
}
